/**
*
* RefundPolicy
*
*/

import React, { Fragment, PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { shape } from 'prop-types';
import { Row, Col, Card } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import BreadCrumb from '../../components/Breadcrumb';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import StyledRefundPolicy from './StyledRefundPolicy';
import { selectRefundPolicy } from './selectors';
import { constants } from '../../devUtils';
class RefundPolicy extends PureComponent {
  renderContent(type) {
    switch (type) {
      case 'manipal':
        return (
          <Fragment>
            <Container>
              <Card className="rounded card-padding-20 margin-t-4 margin-b-4">
                <Row type="flex" align="top">
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <h1 className="heading margin-b-2">REFUND &amp; RETURN POLICY</h1>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <strong className="heading font-16">Exchange of Product: </strong>
                    <span className="font-16 heading">(If the customer wants to exchange the product)</span>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-2">
                    <strong className="heading font-16">Action Plan</strong>
                    <p className="heading font-16 margin-t-2">
                        Product Exchange is only applicable in the Apparel category. Exchange requests from no other product
                        category apart from apparel category will be accepted by Zaggle. Customer can only exchange a
                        product if a different size has been shipped from Zaggle with reference to the order size. Once the
                        Zaggle team receives the shipped product in unused condition, correct size will be shipped to the
                        customer.
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-2">
                    <strong className="heading font-16">Damage Product: </strong>
                    <span className="font-16 heading">(If damaged product has been delivered to the customer)</span>
                    <br /><br />
                    <strong className="heading font-16">Action Plan</strong>
                    <p className="heading font-16 margin-t-2">
                        If damaged product has been delivered to the customer Zaggle Team will investigate and check with
                        the logistics partner regarding damage reasons. If it is transit damage, Zaggle will be responsible for
                        the product replacement and would deliver it within seven working days post the receipt of the
                        damaged product. If the damage has occurred from the customer&apos;s side, there will be no product
                        replacement/refund. In either case, the customer has to shoot a video while unpacking the product
                        to claim a product exchange.
                    </p>
                  </Col>
                </Row>
              </Card>
            </Container>
          </Fragment>
        );
      default:
        return (
          <Fragment>
            <BreadCrumb />
            <StyledRefundPolicy>
              <Container>
                <WhiteBackground>
                  <h1>Refund Policy</h1>
                  <ul>
                    <li>Cancellation and Refunds is not applicable on E-Gift Cards</li>
                    <li>Physical Gift Cards can be cancelled as long as they have not been dispatched by us</li>
                    <li>Refund will be processed within 5-7 working days post cancellation</li>
                    <li> Expired Gift Cards are not redeemable and Gift Card amounts will not be refunded or credited when expired</li>
                    <li> Defaced, mutilated, altered, lost or stolen vouchers will not be replaced, refunded or redeemed</li>
                    <li> Physical Gift Cards and e-Gift Cards can’t be exchanged for cash</li>
                  </ul>
                </WhiteBackground>
              </Container>
            </StyledRefundPolicy>
          </Fragment>
        );
    }
  }

  render() {
    const {
      history: {
        location: {
          pathname,
        },
      },
    } = this.props;
    return (
      <div>
        { pathname === constants.LINK_MANIPAL_REFUN_RETURN_POLICY ? this.renderContent('manipal') : this.renderContent()}
      </div>
    );
  }
}

RefundPolicy.propTypes = {
  history: shape({}).isRequired,
};

const mapStateToProps = createStructuredSelector({
  RefundPolicy: selectRefundPolicy(),
});

const component = connect(mapStateToProps, null)(AppWrappperHOC(RefundPolicy));
export default component;



// WEBPACK FOOTER //
// client/containers/RefundPolicy/index.js